import script from "./Popover.vue?vue&type=script&lang=ts&setup=true"
export * from "./Popover.vue?vue&type=script&lang=ts&setup=true"

import "./Popover.vue?vue&type=style&index=0&id=70fabe9a&lang=scss&scoped=true"
import "./Popover.vue?vue&type=style&index=1&id=70fabe9a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70fabe9a"]])

export default __exports__